import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureCreatorProjectsHttp(opts) {
  http = createCallchainHttp({ ...opts, basePath: '/api' })
}

function requireHttp() {
  if (http === null) throw new Error('configureCreatorProjectsHttp must be called before use')
  return http
}

export function listCreatorProjects(status = null) {
  return requireHttp().get('/admin/visual-game/creator-projects', {
    query: { status },
    routeId: 'visualGame.creatorProjects.list',
  })
}

export function getCreatorProject(id) {
  return requireHttp().get(`/admin/visual-game/creator-projects/${encodeURIComponent(id)}`, {
    routeId: 'visualGame.creatorProjects.get',
  })
}

export function getCreatorProjectAsset(id, assetIndex) {
  return requireHttp().getBlob(`/admin/visual-game/creator-projects/${encodeURIComponent(id)}/assets/${assetIndex}`, {
    routeId: 'visualGame.creatorProjects.asset',
  })
}

export function getCreatorProjectInputAttachment(id, attachmentIndex) {
  return requireHttp().getBlob(`/admin/visual-game/creator-projects/${encodeURIComponent(id)}/input-attachments/${attachmentIndex}`, {
    routeId: 'visualGame.creatorProjects.inputAttachment',
  })
}

export function createCreatorProjectPreview(id) {
  return requireHttp().post(`/admin/visual-game/creator-projects/${encodeURIComponent(id)}/preview`, {
    routeId: 'visualGame.creatorProjects.preview',
  })
}

export function startCreatorProject(id) {
  return requireHttp().post(`/admin/visual-game/creator-projects/${encodeURIComponent(id)}/start`, {
    routeId: 'visualGame.creatorProjects.start',
  })
}

export function retryCreatorProject(id, restartStep = null) {
  return requireHttp().post(`/admin/visual-game/creator-projects/${encodeURIComponent(id)}/retry`, {
    body: restartStep === null ? {} : { restart_step: restartStep },
    routeId: 'visualGame.creatorProjects.retry',
  })
}

export function approveCreatorProject(id) {
  return requireHttp().post(`/admin/visual-game/creator-projects/${encodeURIComponent(id)}/approve`, {
    routeId: 'visualGame.creatorProjects.approve',
  })
}

export function rejectCreatorProject(id, reason) {
  return requireHttp().post(`/admin/visual-game/creator-projects/${encodeURIComponent(id)}/reject`, {
    body: { reason },
    routeId: 'visualGame.creatorProjects.reject',
  })
}
